/** @jsx jsx */
import { useContext } from 'react';
import { jsx } from '@emotion/core';
import { useTranslation } from 'react-i18next';

import { ChallengeGoalsAndConditions, ChallengeSection } from 'components';
import { CHALLENGE_PHASE } from 'constants/challenges';
import { ChallengeListDetailsContext } from '..';
import * as S from './styles';

export default function GoalsAndRewardsSection() {
  const { t } = useTranslation();
  const { challenge, challengeResult, currentPhase } = useContext(
    ChallengeListDetailsContext,
  );
  const isDisabled = currentPhase === CHALLENGE_PHASE.AFTER_CHALLENGE;

  return (
    <ChallengeSection
      defaultExpanded={!challengeResult}
      title={<strong>{t('challenges.detail.goalsAndRewards.title')}</strong>}
      isDisabled={isDisabled}
    >
      <S.Container>
        <ChallengeGoalsAndConditions
          challengeConditions={challenge.conditions}
          challengeResults={challenge.challengeResults}
          goals={challenge.challengeGoals}
          goalType={challenge.goalType}
          disabled={isDisabled}
        />
      </S.Container>
    </ChallengeSection>
  );
}
